import React, { useRef, useCallback } from 'react';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';

import TitleBar from '../../../../TitleBar';

import { Form, Row } from '../../../../Form';
import Input from '../../../../Form/Input';

import { Container } from './styles';

function ItemAdd({ goStepBack, fnAdd }) {
  const formRef = useRef();

  const handleConfirmar = useCallback(
    (data) => {
      try {
        fnAdd(data);

        toast.success('Item editado com sucesso');

        goStepBack();
      } catch (err) {
        toast.error(`Ocorreu um erro. ${err}`);
      }
    },
    [fnAdd, goStepBack]
  );

  return (
    <Container>
      <TitleBar title="Adicionar Item">
        <button id="btn-back" type="button" onClick={goStepBack}>
          Voltar
        </button>
        <button id="btn-submit" type="submit">
          Gravar
        </button>
      </TitleBar>
      <Form ref={formRef} onSubmit={handleConfirmar}>
        <Row>
          <Input id="item" name="item" label="Item" />
          <Input id="partnumber" name="partnumber" label="Código" />
        </Row>
        <Row>
          <Input id="describe" name="describe" label="Descrição" />
          <Input id="quantity" name="quantity" label="Quantidade" />
        </Row>
        <Input id="note" name="note" label="Nota" />
      </Form>
    </Container>
  );
}

ItemAdd.propTypes = {
  goStepBack: PropTypes.func.isRequired,
  fnAdd: PropTypes.func.isRequired,
};

export default ItemAdd;
